import { getData } from '../../../utils/http';
import Optional from '../../../utils/optional';
import RESPONSE_CODES from '../../../consts/responseCodes';
import { isArray, isDefined } from '../../../utils/isDefined';

export default async function getConnectCount({ url, ignoreSize = false }) {
  let count = 0;
  try {
    const response = await getData({
      options: { url: ignoreSize ? url : `${url}?size=1` },
      errorsToPass: [RESPONSE_CODES.NOT_FOUND, ...RESPONSE_CODES.MITEL_TO_PASS]
    });

    const xTotalCount = response?.headers?.['x-total-count'];

    if (isDefined(xTotalCount)) {
      count = xTotalCount;
    } else {
      count = Optional(response?.data)
        .map(res => {
          if (!isArray(res)) {
            return '-';
          }

          return res.length;
        })
        .or(0);
    }

    return count;
  } catch (e) {
    return '-';
  }
}
